<app-dialog
  [dialogType]="dialogType"
  [primaryActionText]="
    'DIALOG.MISSING_CLIENT_EMAIL.ADD_CLIENT' | uppercase | translate
  "
  [secondaryActionText]="
    'DIALOG.MISSING_CLIENT_EMAIL.TURN_OFF_BANK_TRANSFER' | uppercase | translate
  "
  [trackingDialogName]="trackingDialogName"
  [primaryActionTapped]="primaryActionTrackingAction"
  [secondaryActionTapped]="secondaryActionTrackingAction"
  [hideCloseButton]="true"
  (onPrimaryAction)="onPrimaryAction()"
  (onSecondaryAction)="onSecondaryAction()"
>
  <div class="missing-client-email-bank-transfer-dialog">
    <p class="prompt">
      {{ 'DIALOG.MISSING_CLIENT_EMAIL.PROMPT' | translate }}
    </p>
  </div>
</app-dialog>
